import { LitElement, html, svg } from 'lit';

export class IconBankId24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>BankId logo</title><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 6h3M3 6h3M3 14h3M3 18h3M18 18h3M18 10h3M10.5 10h3M10.5 14h3"></path></svg>`; }
}
if (!customElements.get('f-icon-bank-id24', IconBankId24)) {
  customElements.define('f-icon-bank-id24', IconBankId24);
}